import { render, staticRenderFns } from "./TradeRecentlyViewed.vue?vue&type=template&id=3ca349f2&"
import script from "./TradeRecentlyViewed.vue?vue&type=script&lang=js&"
export * from "./TradeRecentlyViewed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports